import estilos from './servicios/ErrorP.module.css'
import { useRouteError } from "react-router-dom";


function ErrorP() {
    const error = useRouteError();
    console.error(error);
  
    return (
       <>
        <div className={estilos.div} id="error-page">
            <h1 className={estilos.h1}>Oops!</h1>
            <p className={estilos.p}>Lo sentimos, ha ocurrido un error inesperado.</p>
            <p className={estilos.i}>
              <i>{error.statusText || error.message}</i>
            </p>
    </div>
    </>
    );
  };
  
  export default ErrorP;